import React from 'react'
import config from '../../config'
import Small from 'components/@common/Small'

interface ExternalHyperlinkProps {
  id: string
  href: string
  wording: string
}

const ExternalHyperlink: React.FC<ExternalHyperlinkProps> = ({
  id,
  href,
  wording,
}) => (
  <a
    id={id}
    href={`${config.SITE_URL}/${href}`}
    target='_blank'
    rel='noreferrer'
  >
    {wording}
  </a>
)

export const ComplianceWording: React.FC = () => (
  <Small>
    To process your application we will verify your identity and may check your
    details with credit reference and fraud prevention agencies. Entering
    incorrect data risks invalidating your policy. By clicking 'continue', you
    confirm you have read and agree to the{' '}
    <ExternalHyperlink
      id='CustomerTOBLink'
      href={'terms-conditions'}
      wording={'customer terms of business'}
    />{' '}
    and{' '}
    <ExternalHyperlink
      id='PrivacyPolicyLink'
      href={'privacy-policy'}
      wording={'privacy policy'}
    />
    .
  </Small>
)
